<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aHFyQi/tc-custom/9781626817517.jpg?1734325842896" alt="This image is the cover for the book Lion at the Door"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lion at the Door
      </h1>
      <p class="bookDescription body article font2">
        <b>A harrowing thriller from the author of the acclaimed <i>Cutter and Bone</i>, “one of the truly great American writers of the 20th century” (<i>The Guardian</i>).</b><br/>  <br/> After losing his wife, his parents, and his family farm, Tom Kohl is staying with his cousin Ken in Seattle as he tries to put his life back together. But things only go from bad to worse when Ken kills a man in a hit-and-run—a man who turns out to be the brother of Tony Jack Giacalone, Seattle’s top mobster. Out of loyalty to his cousin, Tom agrees to help cover up the killing. But when he’s spotted ditching the car by a cocktail waitress—who happens to be the girlfriend of a low-level mobster—the stakes only get higher, and Tom must face what he’s willing to do for family when his life is on the line.<br/>  <br/> “[A] taut tale, in language as well as in action, with suspense stretched wiretight.” —<i>The Christian Science Monitor</i><br/>  <br/> “Swift prose and guaranteed action.” —<i>Los Angeles Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Newton Thornburg
      </h2>
      
      <p class="authorDescription body article">Born in Harvey, Illinois, Newton&#160;Thornburg graduated from the University of Iowa with a fine arts degree. He worked in a variety of jobs before devoting himself to writing full-time (or at least in tandem with his cattle farm in the Ozarks) in 1973.<BR /><BR /> His 1976 novel <I>Cutter and Bone</I> was filmed in 1981 as <I>Cutter&#39;s Way</I>. The <I>New York Times</I> called <I>Cutter and Bone</I> &quot;the best novel of its kind for ten years.&quot; Another novel-to film <I>Beautiful Kate</I> was filmed in Australia in 2009 and starred Bryan Brown and Ben Mendelsohn. It was directed by Rachel Ward, who is Bryan Brown&#39;s real-life wife.<BR /><BR /> Thornburg died on May 9, 2011, a few days shy of his eight-second&#160;birthday.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ddb50e56